import { useState, useEffect } from 'react';

const DateFinder = ({ mydate }) => {
  const [date, setDate] = useState();
  const [time, setTime] = useState();

  useEffect(() => {
    const dateObject = new Date(mydate * 1000);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = dateObject.toLocaleDateString(undefined, options);

    // Format the time
    const formattedTime = dateObject.toLocaleTimeString();

    // Set the state
    setDate(formattedDate);
    setTime(formattedTime);
  }, [mydate]);

  return (
    <span>
      {time} / {date}
    </span>
  );
};

export default DateFinder;